import { ModalErrorConfig } from '@core/interfaces/modal-error-config.interface';
import { PROJECT_TYPE } from '@core/types/projects.type';

export const TIME_OUT_CONFIG = new Map<PROJECT_TYPE, ModalErrorConfig>([
  [
    'ACC',
    {
      imageUrl: {
        url: 'assets/img/errors/error__page-not-found.svg',
        altUrl: 'Information for page not found icon/illustration',
      },
      errorTitle: 'Se agotó el tiempo',
      errorDescription: 'El tiempo límite para abrir tu cuenta terminó.',
      buttonLabel: 'Volver al inicio',
    },
  ],
  [
    'PLD',
    {
      imageUrl: {
        url: 'assets/img/errors/error__page-not-found.svg',
        altUrl: 'Information for page not found icon/illustration',
      },
      errorTitle: 'Se agotó el tiempo',
      errorDescription: 'El tiempo límite para solicitar tu préstamo terminó.',
      buttonLabel: 'Volver al inicio',
    },
  ],
  [
    'FTD',
    {
      imageUrl: {
        url: 'assets/img/errors/error__page-not-found.svg',
        altUrl: 'Information for page not found icon/illustration',
      },
      errorTitle: 'Se agotó el tiempo',
      errorDescription: 'El tiempo límite para abrir tu depósito a plazo fijo terminó.',
      buttonLabel: 'Volver al inicio',
    },
  ],
  [
    'ENROLLMENT',
    {
      imageUrl: {
        url: 'assets/img/errors/error__page-not-found.svg',
        altUrl: 'Information for page not found icon/illustration',
      },
      errorTitle: 'Se agotó el tiempo',
      errorDescription: 'El tiempo límite para crear tu usuario terminó.',
      buttonLabel: 'Volver al inicio',
    },
  ],
]);
